import { useSectionMetaData } from '@v4/components/common/SectionItem'

export const usePopup = ({ variant, Element }) => {
	const metaData = useSectionMetaData()

	return [
		{
			metaData,
			Element,
			variant,
		},
	]
}
